import { getParent, types, flow, clone, applySnapshot } from "mobx-state-tree";
import { values } from "mobx";
import axios from "../../store/axios";
import dayjs from "dayjs";
import DateTime from "src/store/DateTime";

export const ValueLabelEntry = types.model("ValueLabelEntry", {
  value: types.integer,
  label: types.string,
});

export const TransferRequestStoreInitial = {
  entity: {
    brand: null,
    dealer: null,
    branch: null,
  },
  success: false,
  brands: [],
  dealers: [],
  branches: [],
  // selectedBrand: null,
  // selectedDealer: null,
  // selectedBranch: null,
};

export const TransferRequestEntity = types
  .model("TransferRequestEntity", {
    brand: types.maybeNull(ValueLabelEntry),
    dealer: types.maybeNull(ValueLabelEntry),
    branch: types.maybeNull(ValueLabelEntry),
    selectedBrandId: types.maybeNull(types.integer),
    selectedDealerId: types.maybeNull(types.integer),
    selectedBranchId: types.maybeNull(types.integer),
  })
  .actions((self) => {
    return {
      edit(name, value) {
        console.log("entity edit ", name, value);
        self[name] = value;
      },
      update: flow(function* () {
        // const data = {
        //   displayName_ENG: self.displayName_ENG,
        //   brandId: self.selectedBrandId,
        //   dealerId: self.selectedDealerId,
        //   branchId: self.selectedBranchId,
        //   birthday: self.birthday,
        // };
        const updateData = {
          brandId: self.selectedBrandId,
          dealerId: self.selectedDealerId,
          branchId: self.selectedBranchId,
        };
        console.log("dataToUpdate:", updateData);
        yield axios.put(`profile/trainer/request-transfer`, updateData);
        getParent(self, 1).setSuccess(true);
      }),
    };
  });

export const TransferRequestStore = types
  .model("TransferRequestStore", {
    entity: TransferRequestEntity,
    success: types.boolean,
    brands: types.array(ValueLabelEntry),
    dealers: types.array(ValueLabelEntry),
    branches: types.array(ValueLabelEntry),
    // selectedBrand: types.maybeNull(types.reference(ValueLabelEntry)),
    // selectedDealer: types.reference(ValueLabelEntry),
    // selectedBranch: types.reference(ValueLabelEntry),
  })
  .views((self) => ({
    get Brands() {
      return values(self.brands);
    },
    get Dealers() {
      return values(self.dealers);
    },
    get Branches() {
      return values(self.branches);
    },
  }))
  .actions((self) => {
    return {
      setSuccess(val) {
        self.success = val;
      },
      selectBrand(valueLabel) {
        self.selectedBrand = valueLabel;
      },
      selectDealer(valueLabel) {
        self.selectedDealer = valueLabel;
      },
      selectBranch(valueLabel) {
        self.selectedBranch = valueLabel;
      },
      reset() {
        applySnapshot(self, TransferRequestStoreInitial);
      },
      edit(name, value) {
        self[name] = value;
          console.log("TransferRequest edit", name, value);
      },
      fetchEdit: flow(function* (id) {
        let result;
        if (id) {
          result = yield axios.get(`profile/transfer-request/${id}`);
        } else {
          result = yield axios.get(`profile/transfer-request`);
        }
        console.log("fetchEdit", result.data);
        
        applySnapshot(self.entity, result.data);
        // 사용자가 드롭다운을 건드리지 않은 필드도 payload 에 실려야 한다.
        // selected*Id 는 SelectItem 의 onChange 에서만 채워지는데, 서버의
        // TransferRequestViewModel 은 DealerId/BranchId 가 non-nullable int 라
        // null 이 가면 바인딩이 깨져 model 이 null 로 들어오고 500 이 된다.
        // (브랜드만 바꾸는 관리자 시나리오가 정확히 이 경로였다 — #739)
        self.entity.edit("selectedBrandId", result.data.brand.value);
        self.entity.edit("selectedDealerId", result.data.dealer.value);
        self.entity.edit("selectedBranchId", result.data.branch.value);
        yield self.fetchDealer({ brandId: result.data.brand.value });
        yield self.fetchBranch({ dealerId: result.data.dealer.value });
      }),
      // 브랜드를 바꾸면 이전 브랜드의 딜러/서비스센터가 그대로 남아 있으면 안 된다.
      // (남으면 브랜드만 바꿔 제출했을 때 다른 브랜드의 딜러가 저장된다 — #739)
      changeBrand: flow(function* (brandId) {
        self.entity.edit("selectedBrandId", brandId);
        self.entity.edit("selectedDealerId", null);
        self.entity.edit("selectedBranchId", null);
        self.branches = [];
        yield self.fetchDealer({ brandId });
      }),
      changeDealer: flow(function* (dealerId) {
        self.entity.edit("selectedDealerId", dealerId);
        self.entity.edit("selectedBranchId", null);
        yield self.fetchBranch({ dealerId });
      }),
      fetchBranch: flow(function* ({ dealerId }) {
        const result = yield axios.get(`profile/branches/${dealerId}`);
        console.log("fetch branches", result.data);
        self.branches = result.data;
      }),
      fetchDealer: flow(function* ({ brandId }) {
        console.log("fetch dealers brandId", brandId);
        const result = yield axios.get(`profile/dealers/${brandId}`);
        console.log("fetch dealers", result.data);
        self.dealers = result.data;
      }),
      fetchBrands: flow(function* () {
        const result = yield axios.get("profile/brands");
        console.log("fetch brands", result.data);
        self.brands = result.data;
        // applySnapshot(self.brands, result.data);
      }),
      handleBlur(fieldName) {
        self.touched[fieldName] = true;
      },

      requestTransfer: flow(function* () {
        const dataUpload = {
          brandId: self.entity.selectedBrandId,
          dealerId: self.entity.selectedDealerId,
          branchId: self.entity.selectedBranchId,
        };
        console.log("transfer-request", dataUpload);
        const result = yield axios.put("profile/transfer-request", dataUpload);
        self.success = true;
      }),

      transfer: flow(function* (id) {
        const dataUpload = {
          brandId: self.entity.selectedBrandId,
          dealerId: self.entity.selectedDealerId,
          branchId: self.entity.selectedBranchId,
        };
        console.log("transfer",id, dataUpload);
        const result = yield axios.put(`profile/transfer/${id}`, dataUpload);
        self.success = true;
      }),
    };
  });

export default TransferRequestStore;
